import newPageObject from './newPageObject';

const VALID_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/svg+xml',
  'image/svg',
  'image/bmp',
];

const VALID_VIDEO_MIME_TYPES = ['video/mp4', 'video/webm', 'video/mov', 'video/ogg'];

const VALID_DOCUMENT_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/xml',
  'text/xml',
  'text/plain',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
];

export { VALID_DOCUMENT_MIME_TYPES, VALID_VIDEO_MIME_TYPES, VALID_IMAGE_MIME_TYPES, newPageObject };
